import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { setSuccess } from '../../Redux/AlertReducer';

const SuccessAlert = ({ message = 'The Operation Was Successful!' }) => {
  const dispatch = useDispatch();
  const Success = useSelector((state) => state.Alert.Success);
  const handleSnackbarClose = () => {
    dispatch(setSuccess(false));
  };

  return (
    <Snackbar
      open={Success}
      autoHideDuration={3000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ marginTop: '55px' }}
    >
      <Alert
        onClose={handleSnackbarClose}
        severity="success"
        sx={{
          width: '100%',
          backgroundColor: '#28a745',
          color: 'white',
          fontWeight: 'bold',
          '& .MuiAlert-icon': {
            color: '#ffffff',
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SuccessAlert;
